<template>
    <div class="container">
        <div class="dep-title">
            <span>培训管理 》课程排班管理</span>
        </div>
        <div class="queryBox" style="background-color: #fff;">
            <div style="margin-left: 16px;height: 60px;">
                <el-form ref="ruleForm" :inline="true" :model="ruleForm" style="display: flex;flex-wrap: wrap;">
                    <div style="height: 60px;">
                        <el-form-item label="开始日期：" prop="start_date">
                            <el-date-picker
                                v-model="ruleForm.start_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择开始日期"
                                style="width: 180px;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期：" prop="end_date">
                            <el-date-picker
                                v-model="ruleForm.end_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择结束日期"
                                style="width: 180px;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="form-btn" style="margin-left: 20px;">
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="onSubmit">查询</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="clearItem">重置</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="con-center" ref="userbodytable">
            <div class="sm-server-unsetdiv con-center-left" :style="{ width: userzuwidth }" style="padding-right: 0px;">
                <div class="con-center-left-title">
                    <template v-if="foldshow == true">
                        <div>
                            <span class="dot userzudot"></span>
                            <span v-show="foldshow == true">课程列表</span>
                        </div>
                        <i @click="foldshowclick" class="el-icon-s-fold xiaosho" style="font-size: 20px;"></i>
                    </template>
                    <i v-else @click="foldshowclick" class="el-icon-s-unfold xiaosho"
                        style="font-size: 20px;flex: 1;"></i>
                </div>
                <ul class="joblist" v-if="foldshow">
                    <li class="xiaosho" :class="{ userzuzijili: leftMenuClassStatus == index }"
                        style="border-bottom: 1px solid #EBEEF5; margin-top: 1px;padding: 8px 10px 8px 15px;"
                        v-for="(item, index) in leftzulist" :key="index" @click="roleList(index)">
                        <span>
                            <span>{{ item.outline_name }}</span> <br>
                        </span>
                    </li>
                </ul>
                <div class="joblist" v-else></div>
            </div>
            <div :span="20" class="sm-server-unsetdiv con-center-right">
                <div class="action-bar" style="background-color: #fff; padding: 10px 15px;  ">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd('single')">新增单日排班</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd('continuous')">新增连续日排班</el-button>
                </div>
                <div class="data-list" style="margin-top: 5px;">
                    <el-table :data="tableData" stripe border style="padding-left: 0px;"
                        :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'"
                        v-loading="loading" element-loading-text="数据正在加载中">
                        <el-table-column label="课程名称" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{ scope.row.outline_name || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="企业名称" :show-overflow-tooltip="true" min-width="150">
                            <template slot-scope="scope">
                                {{ scope.row.enterprise_name ? decodeURIComponent(scope.row.enterprise_name) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="授课讲师" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.instructor || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="排班日期" width="110">
                            <template slot-scope="scope">
                                {{ scope.row.schedule_date || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="开始时间" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.start_time || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="结束时间" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.end_time || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" width="110">
                            <template slot-scope="scope">
                                {{ scope.row.ctime ? scope.row.ctime.substring(0, 10) : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="80">
                            <template v-slot="{ row }">
                                <el-button @click="handleDelete(row)" type="text" size="small" style="color: red;">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="cr_footer">
                    <div class="footer_left"></div>
                    <div class="footer_right">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" background
                            layout="total,prev, pager, next,jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <scheduleAdd ref="scheduleAddRef" :outline-id="currentOutlineId" :outline-name="currentOutlineName" :instructor="currentInstructor" @ok="onSubmit"></scheduleAdd>

        <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="420px" append-to-body class="delete-dialog">
            <div class="delete-confirm-content" style="padding: 20px 30px;display:flex;align-items:center;"> 
                <i class="el-icon-warning" style="font-size: 22px; color: #E6A23C; margin-right: 10px;"></i>
                <span>确认要删除该课程排班？</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmDelete" :loading="deleteConfirmLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import scheduleAdd from './scheduleAdd.vue';

export default {
    name: "schedules",
    components: {
        scheduleAdd
    },
    data() {
        return {
            currentPage: 1,
            pagesize: 10,
            ruleForm: {
                start_date: '',
                end_date: '',
            },
            tableData: [],
            total: 0,
            loading: false,
            leftzulist: [],
            leftMenuClassStatus: -1,
            foldshow: true,
            userzuwidth: '200px',
            currentOutlineId: '',
            currentOutlineName: '',
            currentInstructor: '',
            deleteDialogVisible: false,
            deleteConfirmLoading: false,
            deleteRow: null,
        };
    },
    mounted() {
        this.getCurseList();
    },
    methods: {
        getCurseList() {
        this.$tools.asyncPost(
            this,
            this.$baseUrl.trainingCourseList, {
            data: {
                page: 1,
                limit: 1000,
                enterprise_id: localStorage.getItem("enterprise_id")
            }
        }).then((res) => {
                if (res.data.code === 0) {
                    this.leftzulist = res.data.data.data || [];
                    if (this.leftzulist.length > 0) {
                        this.leftMenuClassStatus = 0;
                        this.currentOutlineId = this.leftzulist[0].outline_id;
                        this.currentOutlineName = this.leftzulist[0].outline_name;
                        this.currentInstructor = this.leftzulist[0].instructor || '';
                        this.onSubmit();
                    }
                } else {
                    this.$message({ type: "error", message: res.data.msg });
                }
            });
        },
        roleList(index) {
            this.leftMenuClassStatus = index;
            this.currentPage = 1;
            this.currentOutlineId = this.leftzulist[index].outline_id;
            this.currentOutlineName = this.leftzulist[index].outline_name;
            this.currentInstructor = this.leftzulist[index].instructor || '';
            this.onSubmit();
        },
        onSubmit() {
            this.loading = true;
            let params = {
                page: this.currentPage,
                limit: this.pagesize,
            };
            if (this.currentOutlineId) {
                params.outline_id = this.currentOutlineId;
            }
            if (this.ruleForm.start_date) {
                params.start_date = this.ruleForm.start_date;
            }
            if (this.ruleForm.end_date) {
                params.end_date = this.ruleForm.end_date;
            }

            this.$tools.asyncPost(
                this,
                this.$baseUrl.hrcourseschedList, {
                data: params
            }).then((res) => {
                if (res.data.code === 0) {
                    this.tableData = res.data.data.data || [];
                    this.total = res.data.data.total || 0;
                } else {
                    this.$message({ type: "error", message: res.data.msg });
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        handleAdd(mode) {
            this.$refs.scheduleAddRef.open(mode);
        },
        handleDelete(row) {
            this.deleteRow = row;
            this.deleteDialogVisible = true;
        },
        confirmDelete() {
            this.deleteConfirmLoading = true;
            this.$tools.asyncPost(
                this,
                this.$baseUrl.hrcourseschedDelete, {
                data: {
                    id: this.deleteRow.id
                }
            }).then((res) => {
                if (res.data.code === 0) {
                    this.$message({ type: 'success', message: '删除排班成功' });
                    this.deleteDialogVisible = false;
                    this.onSubmit();
                } else {
                    this.$message({ type: "error", message: res.data.msg });
                }
            }).catch(() => {});
            this.deleteConfirmLoading = false;
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.currentPage = 1;
            this.onSubmit();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.onSubmit();
        },
        clearItem() {
            this.ruleForm.start_date = '';
            this.ruleForm.end_date = '';
            this.currentPage = 1;
            this.pagesize = 10;
            this.onSubmit();
        },
        foldshowclick() {
            this.foldshow = !this.foldshow;
            this.userzuwidth = this.foldshow ? "200px" : "35px";
        },
    },
};
</script>
<style scoped lang="less">
.container {
    height: calc(100% - 33px);
    box-sizing: border-box;
    background: #f2f2f2;
    padding: 10px 8px 0px 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .queryBox {
        height: 60px;
    }

    .dep-title {
        height: 50px;
        width: 100%;
        padding-top: 10px;
        background: #fff;
        border-bottom: 10px solid #f2f2f2;
    }

    .dep-title span {
        display: block;
        width: 50%;
        height: 20px;
        font-weight: bold;
        text-indent: 10px;
        line-height: 20px;
        font-size: 14px;
        border-left: 4px solid #0079FE;
        margin-left: 5px;
    }



    .con-center {
        flex: 1;
        display: flex;
        margin-top: 5px;
        height: 100%;
        overflow: hidden;

        .con-center-left {
            height: 100%;

            .con-center-left-title {
                display: flex;
                width: 100%;
                background: #fff;
                padding: 5px;
                height: 40px;
                line-height: 40px;
                white-space: nowrap;
                box-sizing: border-box;
                justify-content: space-between;
                align-items: center;
            }

            .joblist {
                height: calc(100% - 40px - 1px);
                margin-top: 1px;
                background: #fff;
                overflow-y: auto;

                li {
                    transition: all 0.3s;
                }

                li:hover {
                    background: #f0f9ff;
                }

                .userzuzijili {
                    background: #ecf5ff;
                    border-left: 2px solid #409eff;
                    color: #409eff;
                }

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 1px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(236, 236, 236, 0.1);
                    background: #ccc;
                }

                &::-webkit-scrollbar-track {
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(236, 236, 236, 0.1);
                    background: #ededed;
                }
            }
        }

        .con-center-right {
            height: 100%;
            flex: 1;
            margin-left: 5px;
            display: flex;
            flex-direction: column;
            min-width: 0;

            .data-list {
                flex: 1;
                margin-top: 1px;
                background: #f9fafd;
                overflow-y: auto;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 1px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(236, 236, 236, 0.1);
                    background: #ccc;
                }

                &::-webkit-scrollbar-track {
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(236, 236, 236, 0.1);
                    background: #ededed;
                }
            }
        }
    }
}
</style>

<style lang="less">
.delete-dialog {
    .el-dialog__body {
        padding: 0;
    }

    .delete-confirm-content {
        display: flex;
        align-items: flex-start;
        padding: 20px 30px 10px;
        font-size: 14px;
        line-height: 1.5;

        .el-icon-warning {
            margin-top: 2px;
            flex-shrink: 0;
        }
    }
}
